import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { initAnalytics } from "@/lib/analytics";
import { warmBackend } from "@/lib/api";

initAnalytics();
window.addEventListener("cookie-consent", initAnalytics);

// Réveil anticipé du serveur de formulaires, une fois la page affichée.
if ("requestIdleCallback" in window) window.requestIdleCallback(() => warmBackend(), { timeout: 4000 });
else window.setTimeout(warmBackend, 3000);

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
